import script from "./sf-input-base.vue?vue&type=script&setup=true&lang=ts&generic=MV"
export * from "./sf-input-base.vue?vue&type=script&setup=true&lang=ts&generic=MV"

import "./sf-input-base.vue?vue&type=style&index=0&id=95483eae&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95483eae"]])

export default __exports__